

























































import { Component } from "vue-property-decorator";
import feather from "feather-icons";
import { mixins } from "vue-class-component";
import ConnectToRoomCall from "@/resources/mixins/chime/connectToRoomCall";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
@Component({
  name: "room-pin-modal-component",
})
export default class RoomPinModalComponent extends mixins(
  ConnectToRoomCall,
  NotificationEvent
) {
  input1 = "";
  input2 = "";
  input3 = "";
  input4 = "";
  loading = false;
  error = false;
  mounted(): void {
    feather.replace();
    const inputs = document.querySelectorAll(
      "input.pin-input"
    ) as unknown as HTMLInputElement[];
    inputs[0].focus();
    inputs.forEach((input, key) => {
      if (key !== 0) {
        input.addEventListener("click", () => {
          inputs[0].focus();
        });
      }
      input.addEventListener("keyup", async (e) => {
        if (input.value) {
          var regex = new RegExp("^[0-9]+$");
          if (!regex.test(input.value)) {
            inputs[key].value = "";
            return;
          } else {
            inputs[key].value = input.value;
          }
          if (key === 3) {
            // Last one tadaa
            /* const userCode = [...inputs].map((input) => input.value).join("");
            codeBlock.classList.remove("hidden");
            code.innerText = userCode; */
            inputs.forEach((input) => (input.className = ""));
            if (!this.isChangeRoomPin) {
              const pin = parseInt(
                this.input1 + this.input2 + this.input3 + this.input4
              );
              this.loading = true;
              this.error = false;
              this.connectToRoomCall(
                this.$store,
                this.$store.getters["MeetingStore/getRoomId"],
                pin
              ).then((value) => {
                if (value) {
                  inputs.forEach((input) => (input.className = "success"));
                  this.$store.dispatch(
                    "SystemStore/setShowPinRoomModalAction",
                    false
                  );
                  this.$store.dispatch(
                    "SystemStore/setIsChangePinAction",
                    false
                  );
                  localStorage.setItem("pin", pin.toString());
                  const currentRoom = this.$store.getters["SystemStore/getCurrentRoom"];
                  if (currentRoom) {
                    this.$store?.dispatch("SystemStore/setOpenNotepadButtonAction", currentRoom.hasNotes);
                    const space = this.$store.getters["SpaceStore/getSpace"];
                    if (space && space.superSpace && space.superSpace.company == "HAWKINGS") {
                      if (currentRoom.bot != null) {
                        this.$store.dispatch("SystemStore/setEducationBotIdAction", currentRoom.bot.id);
                        this.$store.dispatch("SystemStore/setEducationModalAction", true);
                      }
                    }
                  }
                  this.loading = false;              
                } else {
                  this.error = true;
                  inputs.forEach((input) => (input.className = "error"));
                  this.input1 = this.input2 = this.input3 = this.input4 = "";
                  this.loading = false;
                  inputs[0].focus();
                }
              });
            }
          } else {
            inputs[key + 1].value = "";
            inputs[key + 1].focus();
          }
        }
      });
    });
  }
  get isChangeRoomPin(): boolean {
    return this.$store.getters["SystemStore/getIsChangePin"];
  }
  get showPinRoomModal(): boolean {
    return this.$store.getters["SystemStore/getShowPinRoomModal"];
  }
  set showPinRoomModal(e: boolean) {
    this.$store.dispatch("SystemStore/setShowPinRoomModalAction", e);
  }
  get isLoock(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return space.scenario.rooms.filter((a) => a.id === roomId)[0]?.hasPin;
  }
  get isLockedByAdmin(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return space.scenario.rooms.filter((a) => a.id === roomId)[0]
      ?.isLockedByAdmin;
  }
  changeRoomPin(removePin) {
    this.loading = true;
    const pin = parseInt(this.input1 + this.input2 + this.input3 + this.input4);
    this.$store.dispatch("SpaceStore/changeRoomPinAction", {
      roomId: this.$store.getters["MeetingStore/getRoomId"],
      data: { pin: removePin ? null : pin != 0 ? pin : null },
      callback: () => {
        this.onDefault(
          "",
          removePin
            ? i18n.t("roomPin.doneReleaseRoom")
            : i18n.t("roomPin.doneChangePin")
        );
        this.$store.dispatch("SystemStore/setShowPinRoomModalAction", false);
        this.$store.dispatch("SystemStore/setIsChangePinAction", false);
        this.loading = false;
      },
    });
  }
}
